

import React, { useState, useEffect } from 'react';
import { Button, Alert } from "react-bootstrap";
import Popup from 'reactjs-popup';
import moment from 'moment';

import PropTypes from "prop-types";

Ferie.propTypes = {
    value: PropTypes.object,
    annulla: PropTypes.func,
    conferma: PropTypes.func,
    open: PropTypes.bool,
    message: PropTypes.array
}

function Ferie({ value, annulla, conferma, open, message }) {

    const [inizio, setInizio] = useState("");
    const [fine, setFine] = useState("");

    useEffect(() => {
        clear();
        setInizio(value ? moment(value.inizio).format('YYYY-MM-DD') : "")
        setFine(value ? moment(value.fine).add(-1,'days').format('YYYY-MM-DD') : "")
    }, [value, open])

    const clear = () => {
        setInizio("");
        setFine("");
    }

    const confermaFerie = () => {
        if (!inizio || !fine) {
            alert("Attenzione! Impostare sia la data di inizio che di fine periodo")
        } else if (new Date(inizio) > new Date(fine)) {
            alert("Attenzione! La data di inizio periodo è successiva a quella di fine periodo")
        } else {
            const id = value ? value.id : "";
            conferma(inizio, fine, id)
        }
    }

    const annullaFerie = () => {
        annulla()
        clear()
    }

    return (
        <Popup closeOnDocumentClick={false} open={open}><div>
            {
                message && message.map((data, key) => (
                    <Alert variant={data.tipo} id="message" key={key}>
                        {data.descrizione}
                    </Alert>
                ))
            }
            <div className="formGroup" id="ferie">
                <div className="date-container">
                    <div className="date-field">
                        <label htmlFor="inizio" className="inEvidenza">inizio</label>
                        <input
                            className='form-control'
                            id="inizio"
                            type="date"
                            value={inizio}
                            onChange={(event) => {
                                setInizio(event.target.value);
                            }}
                        />
                    </div>
                    <div className="date-field">
                        <label htmlFor="fine" className="inEvidenza">fine</label>
                        <input
                            className='form-control'
                            id="fine"
                            type="date"
                            value={fine}
                            onChange={(event) => {
                                setFine(event.target.value);
                            }}
                        />
                    </div>
                </div>
                <div id="action" className="action">
                    <Button className="btnGenerale" variant="flat" size="sm" id="annulla"
                        onClick={() => { annullaFerie() }}>annulla</Button>
                    <Button className="btnGenerale" variant="flat" size="sm" id="conferma"
                        onClick={() => { confermaFerie() }}>conferma</Button>
                </div>
            </div>
        </div>
        </Popup>)
}


export default Ferie;